import { FC, useEffect, useState } from "react"
import useError from "../../hooks/useError"
import { LiveNotificationsService } from "../../sdk"
import { useChallenge } from "../../stores/challenge"
import Button from "../Button"
import Icon from "../Icon"
import LiveNotificationCard from "../LiveNotificationCard"
import LiveNotificationForm from "../AddLiveNotificationForm"
import Modal from "../Modal"
import { ChallengeSectionProps } from "../../pages/Challenge"
import Message from "../Message"

const ChallengeNotifications: FC<ChallengeSectionProps> = ({
  challenge
}) => {
  const notifications = useChallenge(state => state.notifications)
  const setNotifications = useChallenge(state => state.setNotifications)
  const { handleError } = useError()

  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(!notifications)

  const getNotifications = async(): Promise<void> => {
    try {
      const { data } = await LiveNotificationsService.listChallengeLiveNotifications({
        handler: {
          challengeId: challenge.id
        },
        paginator: {
          offset: 0,
          limit: 100
        }
      })
      setNotifications(data)
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  useEffect(() => {
    if (!notifications) {
      void getNotifications()
    }
  }, [])

  return (
    <>
      {loading
        ? <Icon name="spinner" size={32} />
        : notifications?.length
          ?
          <>
            <div className="flex mb-8">
              <h2 className="text-2xl font-semibold">Notifiche Live</h2>

              <Button
                onClick={(): void => {
                  setModalOpen(true)
                }}
                className="ml-4"
                disabled={loading}
              >
                Aggiungi
              </Button>
            </div>

            <div className="live-notifications__container">
              {notifications && notifications.map(({
                id,
                timestamp,
                title,
                description
              }) => {
                return (
                  <LiveNotificationCard
                    key={id}
                    timestamp={timestamp}
                    title={title}
                    description={description}
                  />
                )
              })}
            </div>
          </>
          :
          <Message title="Nessuna notifica trovata" icon="bell-off">
            <Button onClick={(): void => setModalOpen(true)}>Aggiungi</Button>
          </Message>
      }


      {modalOpen &&
        <Modal close={(): void => setModalOpen(false)} title="Invia Notifica Live">
          <LiveNotificationForm challengeId={challenge.id} onSubmit={async(): Promise<void> => {
            void getNotifications()
            setModalOpen(false)
          }} />
        </Modal>
      }
    </>
  )
}

export default ChallengeNotifications